<template>
  <div id="online-mapping">
    <div class="wrapper">
      <mainHeader class="mainHeader"></mainHeader>
      <img v-for="(value, index) in images" :key="index" v-bind:src="value" v-bind:class="index==4?imageMargin:''" />
      <mainFooter class="mainFooter"></mainFooter>
      <bottomButton :show="true" id="bottomButton" title="在线申请" state="1"  @click="bottomClick"></bottomButton>
    </div>
  </div>

</template>

<script>
import mainHeader from '../view/header'
import mainFooter from '../view/footer'
import bottomButton from '../components/bottom-button3'
export default{
  data () {
    return {
      images: [
        require('../assets/online_pic1.jpg'),
        require('../assets/online_pic2.jpg'),
        require('../assets/online_pic3.jpg'),
        require('../assets/online_pic4.jpg'),
        require('../assets/online_pic5.jpg'),
        require('../assets/online_pic6.jpg')],
      imageMargin: 'image-margin'
    }
  },
  methods: {
    bottomClick: function () {
      this.$router.push({path: 'online-mapping-edit', query: {}})
    }
  },
  watch: {
    $router () {
    }
  },
  components: { // 注册组件
    mainHeader,
    mainFooter,
    bottomButton
  }
}
</script>

<style scoped>
.wrapper{
  background-color: #F6F6F6;
  width: 100%;
  margin-bottom: 70px;
}
.mainHeader{
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
img{
  width: 100%;
  display: block;
}
.image-margin{
  margin-top :-1px;
}
img:first-of-type{
  margin-top: 55px;
}
.mainFooter{
}
</style>



// WEBPACK FOOTER //
// src/view/online-mapping.vue